import { ConfirmAlert } from "../components/Alerts/Alerts";
import {
  ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION,
  ANALYZE_LAYERS_EDIT_TEXT_TITLE,
  ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON,
  ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON,
} from "../i18n/keysTranslations";

/**
 * Ask whether layer analysis should convert detected glyph layers to editable text.
 * Enable → extractText true. Disable (cancel button) → extractText false, still analyze.
 * Closing the dialog (X, backdrop, Esc) aborts analysis.
 */
export const confirmAnalyzeDetectsText = async ({ t }) => {
  const result = await ConfirmAlert({
    title: t(ANALYZE_LAYERS_EDIT_TEXT_TITLE),
    text: t(ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION),
    confirmButtonText: t(ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON),
    cancelButtonText: t(ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON),
    confirmButtonVariant: "secondary",
    cancelButtonVariant: "secondary",
    reverseButtons: true,
    icon: "warning",
  });

  if (result?.isConfirmed) {
    return { proceed: true, extractText: true };
  }
  if (result?.dismiss === "cancel") {
    return { proceed: true, extractText: false };
  }
  return { proceed: false, extractText: false };
};
